type Elements = {
  buttons: HTMLAnchorElement[];
  contents: HTMLDivElement[];
};

type Report = {
  elements: Elements;
  init: () => void;
  handleClick: (e: MouseEvent, button: HTMLAnchorElement) => void;
};

const report: Report = {
  elements: {
    buttons: [],
    contents: [],
  },

  init() {
    this.elements.buttons = Array.from(document.querySelectorAll('.report__menu--items .button'));
    this.elements.contents = Array.from(document.querySelectorAll('.report__content'));

    if (this.elements.buttons.length) {
      this.elements.buttons.forEach(button => button.addEventListener('click', (e) => this.handleClick(e, button)));
    }
  },

  handleClick(e: MouseEvent, button: HTMLAnchorElement) {
    e.preventDefault();
    const { report: index } = button.dataset;
    const content = document.querySelector(`.report__content[data-report="${index}"]`);

    this.elements.buttons.forEach(button => button.classList.remove('active'));
    this.elements.contents.forEach(content => content.classList.remove('active'));

    button.classList.add('active');
    content?.classList.add('active');
  },
};

export default report;
